import React, { useEffect, useState } from 'react';
import { apiService } from 'services/base.service';
import { ReactComponent as DotIcon } from 'assets/icons/dot-icon.svg';
import RequestDetailsWrapper from 'components/base/request-details-wrapper';
import { useParams } from 'react-router-dom';
import { handleApiError } from 'utils/functions';
import { PrepRequestType } from 'models/prep-request.model';

const CompletedRequest = () => {
  const { id } = useParams();
  const [request, setRequest] = useState<PrepRequestType | null>(null);
  const [loading, setLoading] = useState(false);
  const [collapsedMeals, setCollapsedMeals] = useState<number[]>([1]);

  const collapseMeal = (id: number) => {
    const isItemPresent = collapsedMeals.find((item) => item === id);
    if (isItemPresent) {
      setCollapsedMeals(collapsedMeals.filter((item) => item !== id));
    } else {
      setCollapsedMeals([...collapsedMeals, id]);
    }
  };

  const getRequestItems = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await apiService.get(`prep-kitchen-request/${id}`, {
        version: 'v2'
      });
      setRequest(res.data.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRequestItems();
  }, []);

  if (loading || !request) {
    return (
      <div className='flex justify-center items-center py-8'>
        <p className=''>Loading items...</p>
      </div>
    );
  }
  return (
    <RequestDetailsWrapper
      codeId={request.code}
      status={request.status}
      header='Review final report'
      enableBackLink={false}>
      <div>
        {request.items.map((itm, index) => (
          <div key={index}>
            <div className='bg-[#F7F7F7E5] px-4 py-4 flex justify-between w-full items-center'>
              <div>
                <p className=' font-semibold text-lg'>{itm.ingredient.name} </p>
                <div className='flex gap-2 font-medium items-center'>
                  <p className='text-sm text-gray-9'>{itm.quantity_requested} portions</p>
                  <DotIcon color='#D9D9D9' />

                  <p className='text-sm text-[#0080E5] font-semibold'>
                    {itm.quantity_produced} portions produced
                  </p>
                </div>
                {itm.note && (
                  <div className='mt-2'>
                    <p className='text-gray-6 text-sm'>
                      Note: <span className='text-sm text-gray-5'>{itm.note}</span>
                    </p>
                  </div>
                )}
              </div>
              <button
                onClick={() => collapseMeal(index + 1)}
                className='border border-[#EAEBEB] px-4 py-1 bg-white rounded-full'>
                {collapsedMeals.find((item) => item === index + 1) ? 'Hide' : 'Show'}
              </button>
            </div>

            {loading ? (
              <p className='flex justify-center my-5'>Loading ...</p>
            ) : (
              collapsedMeals.find((item) => item === index + 1) &&
              itm.prep_item_ingredients &&
              itm.prep_item_ingredients.map((prep_items, i) => (
                <div key={i} className='gap-5 px-7  py-4 border-t border-t-gray-2 '>
                  <p className='font-semibold'> {prep_items.ingredient.name}</p>
                  <div className='flex gap-2   text-sm font-medium'>
                    <p className='text-[#6F7376] '>
                      {prep_items.quantity_requested}{' '}
                      {prep_items.ingredient.unit_type ?? 'portions'}{' '}
                    </p>
                    {prep_items.quantity_wasted && (
                      <div className='flex gap-1 items-center'>
                        <DotIcon color='#D9D9D9' />

                        <p className='text-[#0080E5]'>
                          {prep_items.quantity_wasted} {prep_items.ingredient.unit_type} wasted
                        </p>
                      </div>
                    )}
                    {prep_items.excess_quantity && (
                      <div className='flex gap-1 items-center'>
                        <DotIcon color='#D9D9D9' />
                        <p className='text-[#0080E5]'>
                          {prep_items.excess_quantity} {prep_items.ingredient.unit_type} in excess
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        ))}
      </div>
    </RequestDetailsWrapper>
  );
};

export default CompletedRequest;
